var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurger(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 3.333,
    rx: 1.667
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8.334,
    width: 25,
    height: 3.333,
    rx: 1.667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 16.666,
    width: 25,
    height: 3.333,
    rx: 1.667
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg viewBox='0 0 25 20' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='25' height='3.33333' rx='1.66667'/%3e %3crect y='8.3335' width='25' height='3.33333' rx='1.66667'/%3e %3crect y='16.6665' width='25' height='3.33333' rx='1.66667'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };